/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelUserSysHealth.ts                 *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/general/user_sys_health";

export class AutogenModelUserSysHealth<RowType extends ModelRow> extends Endpoint<RowType, RowUserSysHealthFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowUserSysHealth extends ModelRow<RowUserSysHealthFields> {
	constructor(values?: Partial<RowUserSysHealthFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowUserSysHealthFields {
	alert_missing_level: string;
	applies_to_class: string;
	comp_add_operand: string;
	comp_operand: string;
	company_id: string;
	custom_alert_class: string;
	dependent_alert_id: string;
	email_body: string;
	id: string;
	important_email: string;
	important_interval: number;
	important_value: string;
	is_dependent_alert: string;
	is_enabled: string;
	last_evaluation: Date;
	last_important: Date;
	last_urgent: Date;
	last_warning: Date;
	perf_alert_def_id: string;
	sys_health_category: string;
	urgent_email: string;
	urgent_interval: number;
	urgent_value: string;
	user_id: string;
	value1_attribute: string;
	value1_metric: string;
	value1_period: string;
	value2_attribute: string;
	value2_metric: string;
	value2_period: string;
	warning_email: string;
	warning_interval: number;
	warning_value: string;
}

